import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { SubmitButton } from "../../components/Input";
import StateManagedSelect from "react-select";
import { API_URL } from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { showToast } from "../../components/toast";

const AddStreetfolioSubscriberForm = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [tableMapping, setTableMapping] = useState([]);
  const [dropdowns, setDropdowns] = useState({
    smsTemplates: [{ value: 0, label: "Select" }],
    pushTemplates: [{ value: 0, label: "Select" }],
    leadSources: [{ value: 0, label: "Select" }],
    userSources: [{ value: 0, label: "Select" }],
    whatsappTemplates: [{ value: 0, label: "Select" }],
    emailTemplates: [{ value: 0, label: "Select" }],
    eventList: [],
    scheduleList: [],
    fieldList: [],
    dateList: [],
    stateList: [],
    userList: [],
  });

  const [workflowFetched, setWorkflowFetched] = useState(false);

  const [workflowName, setWorkflowName] = useState("");
  const [selectedEventTypeOption, setSelectedEventTypeOption] = useState(null);
  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null);
  const [pickTime, setPickTime] = useState("");
  const [selectedCheckFieldList, setSelectedCheckFieldList] = useState(null);
  const [selectedUpdateFieldList, setSelectedUpdateFieldList] = useState(null);

  const [
    selectedAlertLeadSmsSourceSubscriberOption,
    setSelectedAlertLeadSmsSourceSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsSubscriberOption,
    setSelectedAlertLeadSmsSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadPushNotificationSubscriberOption,
    setSelectedAlertLeadPushNotificationSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsSourceExecutiveOption,
    setSelectedAlertLeadSmsSourceExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsExecutiveOption,
    setSelectedAlertLeadSmsExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadPushNotificationExecutiveOption,
    setSelectedAlertLeadPushNotificationExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadWhatsappSubscriberOption,
    setSelectedAlertLeadWhatsappSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertUserWhatsappExecutiveOption,
    setSelectedAlertUserWhatsappExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadEmailSubscriberOption,
    setSelectedAlertLeadEmailSubscriberOption,
  ] = useState(0);

  const [formData, setFormData] = useState({
    checkConditions: [],
    updateConditions: [],
  });

  const convertTimeStringToDate = (timeString) => {
    const [time, modifier] = timeString.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };

  const fetchDropdowns = async () => {
    try {
      const response = await axios.get(
        `${API_URL}workflowSubscriberStreet/dropdowns`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data.data;
      setDropdowns({
        smsTemplates: [
          { value: 0, label: "Select" },
          ...(data.smslist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        pushTemplates: [
          { value: 0, label: "Select" },
          ...(data.pushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        leadSources: [
          { value: 0, label: "Select" },
          ...(data.leadsourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        userSources: [
          { value: 0, label: "Select" },
          ...(data.usersourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        whatsappTemplates: [
          { value: 0, label: "Select" },
          ...(data.whatsapppushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        emailTemplates: [
          { value: 0, label: "Select" },
          ...(data.emailtemplatelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        eventList: (data.eventlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        scheduleList: (data.schedulelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        fieldList: (data.fieldlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        dateList: (data.datelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        stateList: (data.statelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        userList: (data.userlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchTableMapping = async () => {
    try {
      const response = await axios.get(
        `${API_URL}workflowSubscriberStreet/tableMapping`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      setTableMapping(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchWorkflow = async () => {
    if (!id) return;
    try {
      const response = await axios.get(`${API_URL}workflowSubscriberStreet`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const formattedData = response.data.data.data.filter((dt) => dt.id == id);

      const data = formattedData[0];

      setWorkflowName(data.workflow_name || "");
      setSelectedEventTypeOption(data.event_type || null);
      setSelectedScheduleOption(data.scheduletype || null);
      setPickTime(
        data.scheduletime ? convertTimeStringToDate(data.scheduletime) : ""
      );
      const populatedCheckConditions = await Promise.all(
        data.check_json.map(async (cond) => {
          const meta = await getFieldMeta(parseInt(cond.mapid));
          return {
            ...meta,
            mapid: cond.mapid,
            conditionType: cond.conditiontype,
            fieldValue: cond.fieldvalue,
          };
        })
      );

      const populatedUpdateConditions = await Promise.all(
        data.update_json.map(async (cond) => {
          const meta = await getFieldMeta(parseInt(cond.mapid));
          return {
            ...meta,
            mapid: cond.mapid,
            fieldValue: cond.fieldvalue,
          };
        })
      );

      setFormData({
        ...data,
        checkConditions: populatedCheckConditions,
        updateConditions: populatedUpdateConditions,
      });

      setSelectedAlertLeadSmsSourceSubscriberOption(
        data.alert_lead_sms_source !== undefined && data.alert_lead_sms_source !== null
          ? data.alert_lead_sms_source
          : 0
      );
      setSelectedAlertLeadSmsSubscriberOption(
        data.alert_lead_sms !== undefined && data.alert_lead_sms !== null
          ? data.alert_lead_sms
          : 0
      );
      setSelectedAlertLeadPushNotificationSubscriberOption(
        data.alert_lead_push !== undefined && data.alert_lead_push !== null
          ? data.alert_lead_push
          : 0
      );
      setSelectedAlertLeadSmsSourceExecutiveOption(
        data.alert_user_sms_source !== undefined && data.alert_user_sms_source !== null
          ? data.alert_user_sms_source
          : 0
      );
      setSelectedAlertLeadSmsExecutiveOption(
        data.alert_user_sms !== undefined && data.alert_user_sms !== null
          ? data.alert_user_sms
          : 0
      );
      setSelectedAlertLeadPushNotificationExecutiveOption(
        data.alert_user_push !== undefined && data.alert_user_push !== null
          ? data.alert_user_push
          : 0
      );
      setSelectedAlertLeadWhatsappSubscriberOption(
        data.alert_lead_whatsapp_push !== undefined && data.alert_lead_whatsapp_push !== null
          ? data.alert_lead_whatsapp_push
          : 0
      );
      setSelectedAlertUserWhatsappExecutiveOption(
        data.alert_user_whatsapp_push !== undefined && data.alert_user_whatsapp_push !== null
          ? data.alert_user_whatsapp_push
          : 0
      );
      setSelectedAlertLeadEmailSubscriberOption(
        data.alert_lead_email !== undefined && data.alert_lead_email !== null
          ? data.alert_lead_email
          : 0
      );
    } catch (error) {
      console.error("Error fetching workflow data:", error);
      setError("Failed to load workflow data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDropdowns();
    fetchTableMapping();
  }, []);

  useEffect(() => {
    if (tableMapping.length > 0 && dropdowns.stateList.length > 0 && id && !workflowFetched) {
      setWorkflowFetched(true);
      fetchWorkflow();
    } else if (!id && tableMapping.length > 0) {
      setLoading(false); // If no ID, we're in "Add" mode — stop loading manually.
    }
  }, [tableMapping, dropdowns, id, workflowFetched]);

  const getFieldMeta = async (mapId) => {
    const map = tableMapping.find((m) => m.id === mapId);
    if (!map) return null;

    let droplist = [];
    let conditionOptions = {
      "=": "Is Equal To",
      "!=": "Not Equal To",
    };

    const mapid = map.dropid;

    if (map.field_type === "dropdown" && map.field_name === "state") {
      droplist = dropdowns.stateList || [];
    } else if (
      map.field_type === "dropdown" &&
      map.field_name === "assignedto"
    ) {
      droplist = dropdowns.userList || [];
    } else if (map.field_type === "dropdown") {
      try {
        const response = await axios.get(
          `${API_URL}workflowSubscriberStreet/pickuplist_sub?pid=${mapid}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        droplist = response.data.data.map((item) => ({
          label: item.pick_name,
          value: item.pick_name,
        }));
      } catch (error) {
        console.error("Error fetching picklist:", error);
      }
    } else if (map.field_type === "date") {
      droplist = dropdowns.dateList;
    } else {
      conditionOptions = {
        ...conditionOptions,
        "<": "Less Than",
        "<=": "Less Than Equal To",
        ">": "Greater Than",
        ">=": "Greater Than Equal To",
      };
    }

    return {
      mapId: map.id,
      fieldType: map.field_type,
      fieldName: map.field_name,
      fieldLabel: map.field_description,
      fieldOptions: droplist,
      conditionOptions,
    };
  };

  const handleAddCondition = async () => {
    if (!selectedCheckFieldList) return;

    const meta = await getFieldMeta(selectedCheckFieldList);

    if (!meta) return;

    setFormData((prev) => ({
      ...prev,
      checkConditions: [
        ...prev.checkConditions,
        {
          mapId: meta.mapId,
          fieldType: meta.fieldType,
          fieldName: meta.fieldName,
          fieldLabel: meta.fieldLabel,
          conditionType: "",
          fieldValue: "",
          fieldOptions: meta.fieldOptions,
          conditionOptions: meta.conditionOptions,
        },
      ],
    }));
    setSelectedCheckFieldList(null);
  };

  const handleAddUpdateValue = async () => {
    if (!selectedUpdateFieldList) return;

    const meta = await getFieldMeta(selectedUpdateFieldList);

    if (!meta) return;

    setFormData((prevData) => ({
      ...prevData,
      updateConditions: [
        ...prevData.updateConditions,
        {
          mapId: meta.mapId,
          fieldType: meta.fieldType,
          fieldName: meta.fieldName,
          fieldLabel: meta.fieldLabel,
          conditionType: "",
          fieldValue: "",
          fieldOptions: meta.fieldOptions,
          conditionOptions: meta.conditionOptions,
        },
      ],
    }));
    setSelectedUpdateFieldList(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formatTo12Hour = (date) => {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      const hr = hours % 12 || 12;
      const min = minutes.toString().padStart(2, "0");
      return `${hr}:${min} ${ampm}`;
    };

    const formattedCheckCondition = formData.checkConditions.map((item) => ({
      mapid: item.mapId,
      fieldname: item.fieldName,
      fieldvalue: item.fieldValue,
      conditiontype: item.conditionType,
    }));

    const formattedUpdateCondition = formData.updateConditions.map((item) => ({
      mapid: item.mapId,
      fieldname: item.fieldName,
      fieldvalue: item.fieldValue,
    }));

    const payload = {
      workflow_name: workflowName,
      event_type: selectedEventTypeOption,
      scheduletype: selectedScheduleOption ? selectedScheduleOption : "",
      scheduletime: pickTime ? formatTo12Hour(pickTime) : "",
      conditions: formattedCheckCondition,
      updates: formattedUpdateCondition,
      alert_lead_sms: selectedAlertLeadSmsSubscriberOption || 0,
      alert_lead_push: selectedAlertLeadPushNotificationSubscriberOption || 0,
      alert_user_push: selectedAlertLeadPushNotificationExecutiveOption || 0,
      alert_lead_sms_source: selectedAlertLeadSmsSourceSubscriberOption || 0,
      alert_user_sms_source: selectedAlertLeadSmsSourceExecutiveOption || 0,
      alert_lead_email: selectedAlertLeadEmailSubscriberOption || 0,
      alert_user_sms: selectedAlertLeadSmsExecutiveOption || 0,
      alert_lead_whatsapp_push: selectedAlertLeadWhatsappSubscriberOption || 0,
      alert_user_whatsapp_push: selectedAlertUserWhatsappExecutiveOption || 0,
    };

    console.log(payload);

    try {
      const url = id
        ? `${API_URL}workflowSubscriberStreet/save?id=${id}`
        : `${API_URL}workflowSubscriberStreet/save`;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201 || response.status === 200) {
        showToast.success(response.data.message);
        navigate("/Workflow/Subscriber");
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    }
  };

  const handleRemoveCondition = (index) => {
    const newConditions = formData.checkConditions.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, checkConditions: newConditions });
  };

  const handleRemoveUpdateValue = (index) => {
    const newupdateConditions = formData.updateConditions.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, updateConditions: newupdateConditions });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <form onSubmit={handleSubmit}>
          <div className="panel panel-default with-rounded-corner with-shadow">
            <div className="panel-heading border-0">
              <span className="panel-title">
                {id ? "Edit " : "Add "} Workflow Subscriber - Streetfolio
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Workflow Name</label>
                  <input
                    type="text"
                    name="workflow_name"
                    value={workflowName}
                    onChange={(e) => setWorkflowName(e.target.value)}
                    className="form-control"
                    placeholder="Enter Workflow Name"
                  />
                </div>
                <div className="col-md-3">
                  <label>Event Type</label>
                  <StateManagedSelect
                    options={dropdowns.eventList}
                    value={
                      selectedEventTypeOption
                        ? dropdowns.eventList.find(
                          (option) => option.value == selectedEventTypeOption
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedEventTypeOption(selected?.value)
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-3">
                  <label>Schedule Type</label>
                  <StateManagedSelect
                    options={dropdowns.scheduleList}
                    value={
                      selectedScheduleOption
                        ? dropdowns.scheduleList.find(
                          (option) => option.value == selectedScheduleOption
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedScheduleOption(selected?.value)
                    }
                    placeholder="--select--"
                    isDisabled={selectedEventTypeOption !== "schedule"}
                  />
                </div>
                <div className="col-md-2">
                  <label>Pick Time</label>
                  <DatePicker
                    selected={pickTime}
                    onChange={(date) => setPickTime(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    disabled={selectedScheduleOption !== "daily"}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <span className="panel-title">
                    <i className="fa fa-arrow-right"></i> Check Conditions
                  </span>
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Conditions</th>
                        <th>Field Value</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.checkConditions.map((condition, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={condition.fieldLabel}
                                disabled
                              />
                            </td>
                            <td>
                              <select
                                className="form-control"
                                value={condition.conditionType}
                                onChange={(e) => {
                                  const updated = [...formData.checkConditions];
                                  updated[index].conditionType = e.target.value;
                                  setFormData({
                                    ...formData,
                                    checkConditions: updated,
                                  });
                                }}
                              >
                                {Object.entries(
                                  condition.conditionOptions || {}
                                ).map(([val, label]) => (
                                  <option key={val} value={val}>
                                    {label}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {condition.fieldType === "dropdown" ||
                                condition.fieldType === "date" ? (
                                <select
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.checkConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      checkConditions: updated,
                                    });
                                  }}
                                >
                                  <option value="" selected disabled>
                                    --select--
                                  </option>
                                  {condition.fieldOptions?.map((opt, idx) => (
                                    <option key={idx} value={opt.value || opt}>
                                      {opt.label || opt}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.checkConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      checkConditions: updated,
                                    });
                                  }}
                                  placeholder="Enter Value"
                                />
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveCondition(index)}
                              >
                                X
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <StateManagedSelect
                            options={dropdowns.fieldList}
                            value={
                              selectedCheckFieldList
                                ? dropdowns.fieldList.find(
                                  (option) =>
                                    option.value == selectedCheckFieldList
                                )
                                : null
                            }
                            onChange={(selected) =>
                              setSelectedCheckFieldList(selected?.value)
                            }
                            placeholder="--select--"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddCondition}
                          >
                            Add Condition
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <span className="panel-title">
                    <i className="fa fa-arrow-right"></i> Update Values
                  </span>
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Field Value</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.updateConditions.map((condition, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={condition.fieldLabel}
                                disabled
                              />
                            </td>
                            <td>
                              {condition.fieldType === "dropdown" ||
                                condition.fieldType === "date" ? (
                                <select
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.updateConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      updateConditions: updated,
                                    });
                                  }}
                                >
                                  <option value="" selected disabled>
                                    --select--
                                  </option>
                                  {condition.fieldOptions?.map((opt, idx) => (
                                    <option key={idx} value={opt.value || opt}>
                                      {opt.label || opt}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.updateConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      updateConditions: updated,
                                    });
                                  }}
                                  placeholder="Enter Value"
                                />
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveUpdateValue(index)}
                              >
                                X
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <StateManagedSelect
                            options={dropdowns.fieldList}
                            value={
                              selectedUpdateFieldList
                                ? dropdowns.fieldList.find(
                                  (option) =>
                                    option.value == selectedUpdateFieldList
                                )
                                : null
                            }
                            onChange={(selected) =>
                              setSelectedUpdateFieldList(selected?.value)
                            }
                            placeholder="--select--"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddUpdateValue}
                          >
                            Add Update Value
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12 my-2">
                  <span className="panel-title">Alerts:</span>
                </div>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label>Alert Lead SMS Source Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.leadSources}
                      value={
                        selectedAlertLeadSmsSourceSubscriberOption !== null &&
                        selectedAlertLeadSmsSourceSubscriberOption !== undefined
                          ? dropdowns.leadSources.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSourceSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSourceSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead SMS Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.smsTemplates}
                      value={
                        selectedAlertLeadSmsSubscriberOption !== null &&
                        selectedAlertLeadSmsSubscriberOption !== undefined
                          ? dropdowns.smsTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Push Notification Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.pushTemplates}
                      value={
                        selectedAlertLeadPushNotificationSubscriberOption !== null &&
                        selectedAlertLeadPushNotificationSubscriberOption !== undefined
                          ? dropdowns.pushTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadPushNotificationSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadPushNotificationSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead SMS Source Executive</label>
                    <StateManagedSelect
                      options={dropdowns.userSources}
                      value={
                        selectedAlertLeadSmsSourceExecutiveOption !== null &&
                        selectedAlertLeadSmsSourceExecutiveOption !== undefined
                          ? dropdowns.userSources.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSourceExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSourceExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Sms Executive</label>
                    <StateManagedSelect
                      options={dropdowns.smsTemplates}
                      value={
                        selectedAlertLeadSmsExecutiveOption !== null &&
                        selectedAlertLeadSmsExecutiveOption !== undefined
                          ? dropdowns.smsTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Push Notification Executive</label>
                    <StateManagedSelect
                      options={dropdowns.pushTemplates}
                      value={
                        selectedAlertLeadPushNotificationExecutiveOption !== null &&
                        selectedAlertLeadPushNotificationExecutiveOption !== undefined
                          ? dropdowns.pushTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadPushNotificationExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadPushNotificationExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Whatsapp Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.whatsappTemplates}
                      value={
                        selectedAlertLeadWhatsappSubscriberOption !== null &&
                        selectedAlertLeadWhatsappSubscriberOption !== undefined
                          ? dropdowns.whatsappTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadWhatsappSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadWhatsappSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Whatsapp Executive</label>
                    <StateManagedSelect
                      options={dropdowns.whatsappTemplates}
                      value={
                        selectedAlertUserWhatsappExecutiveOption !== null &&
                        selectedAlertUserWhatsappExecutiveOption !== undefined
                          ? dropdowns.whatsappTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertUserWhatsappExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertUserWhatsappExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Email Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.emailTemplates}
                      value={
                        selectedAlertLeadEmailSubscriberOption !== null &&
                        selectedAlertLeadEmailSubscriberOption !== undefined
                          ? dropdowns.emailTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadEmailSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadEmailSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <SubmitButton
                  handleSubmit={handleSubmit}
                  pageBack={`/Workflow/Subscriber`}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStreetfolioSubscriberForm;
